function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import FontAwesome from 'react-fontawesome';
import styled from 'styled-components';

var sizeToPixels = function sizeToPixels(size) {
  switch (size) {
    case '2x':
      return '32px';

    case '3x':
      return '48px';

    case '4x':
      return '64px';

    default:
      return '16px';
  }
};

var Icon = function Icon(_ref) {
  var className = _ref.className,
      fixedWidth = _ref.fixedWidth,
      name = _ref.name,
      src = _ref.src,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["className", "fixedWidth", "name", "src", "size"]);

  if (src == null) {
    return /*#__PURE__*/React.createElement(FontAwesome, _extends({
      className: className,
      fixedWidth: fixedWidth,
      name: name,
      size: size
    }, rest));
  }

  return /*#__PURE__*/React.createElement("span", {
    className: className
  }, /*#__PURE__*/React.createElement("img", _extends({
    height: sizeToPixels(size),
    role: "presentation",
    src: src
  }, rest)));
};

export default styled(Icon).withConfig({
  displayName: "Icon",
  componentId: "sc-1h3oo9z-0"
})([""]);